import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { SpinnerService } from 'src/app/services/spinner.service';
import * as moment from "moment";
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { setConfigTable, basicAlert, timerOut, alertaConfirmacion } from 'src/app/shared/utils';
import { objProveedorFrm } from 'src/app/modulos/archivos/proveedor/nuevoproveedor/objConfiguracionProveedor.model'
import { BuscarService } from 'src/app/services/buscar.service';
import { VendedorService } from 'src/app/services/vendedor.service';
import { ProveedorService } from 'src/app/services/proveedor.service'
import { Proveedor } from 'src/app/models/pproveedor.model';
import { ImportarSunatComponent } from 'src/app/shared/modals/importar-sunat/importar-sunat.component';
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { RecursosService } from 'src/app/services/recursos.service';
import { CpagoComprasService } from 'src/app/services/cpago-compras.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImportarDniComponent } from '../../importar-dni/importar-dni.component';
import { ModificarProveedorComponent } from '../modificar-proveedor/modificar-proveedor.component';

@Component({
  selector: 'app-nuevo-proveedor',
  templateUrl: './nuevo-proveedor.component.html',
  styleUrls: ['./nuevo-proveedor.component.css']
})
export class NuevoProveedorComponent implements OnInit {

  @ViewChild('selectInsertar') selectInsertar: ElementRef;
  @ViewChild('selectModificar') selectModificar: ElementRef;

  vista: number = 1;
  identidad: boolean = true;
  isnatural: boolean = true;
  tamanoidentidad: number;

  tipopersona: any = []
  identidades: any = []

  tident: string = "06  ";
  titulolista: any = []
  vendedores: any = []
  clienteRegimenes: any = []

  condicionespago = [];


  objProveedor = new objProveedorFrm();

  public ParamDocumento = new Proveedor();
  public disabledGuardar: boolean = true;

  public _sunatImage: any = {};
  public _recursos: any = {};
  disable_codigo: any = false;
  sessionInfo: any;

  constructor(
    private ProveedorService: ProveedorService,
    private spinnerService: SpinnerService,
    private modalService: NgbModal,
    private _buscarService: BuscarService,
    private VendedorService: VendedorService,
    private recursosService: RecursosService,
    private interlocutorService: InterlocutorService,
    private cpagoComprasService: CpagoComprasService,
    private toastr: ToastrService,
    private router: Router,
    private modalService2: NgbActiveModal,

  ) { }

  ngOnInit(): void {

    this.spinnerService.activarLoading(true);

    this.sessionInfo = JSON.parse(StorageService.getSession());
    if (this.sessionInfo.factores.codigoProveedorAutomatico != null &&
      this.sessionInfo.factores.codigoProveedorAutomatico == true) {
      this.disable_codigo = true;
    }


    this.recursosService.recursosIC().subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);

      this._recursos = resp.body;
      if (this._recursos != null && this._recursos.personas != null)
        this.tipopersona = this._recursos.personas;
      if (this._recursos != null && this._recursos.identidades != null)
        this.identidades = this._recursos.identidades;
      console.log('aaa')
      console.log(this.identidades)
      if (this._recursos != null && this._recursos.vendedores != null) {
        this.vendedores = this._recursos.vendedores;
        if (this.vendedores.length > 0)
          this.objProveedor.codven = this.vendedores[0].codven;
      }
      if (this._recursos != null && this._recursos.tituloListas != null)
        this.titulolista = this._recursos.tituloListas;
      if (this._recursos != null && this._recursos.impositivos != null) {
        this.clienteRegimenes = this._recursos.impositivos;
        if (this.clienteRegimenes.length > 0)
          this.objProveedor.regret = this.clienteRegimenes[0].codigo;
      }

    }, err => {
      this.spinnerService.activarLoading(false);
    });
    this.ObtenerCondPago();
    this.onNexFocus('Insert')
  }

  private obtenerTipoPersonas() {
    this._buscarService.tipo_personas().subscribe((resp: any) => {
      console.log(resp.body.list);
      this.tipopersona = resp.body.list;
    }, err => {
      console.log(err);
      console.log("Error al cargar tipo de personas")
    })
  }


  public ObtenerCondPago() {
    this.spinnerService.activarLoading(true);
    this.cpagoComprasService.buscar().subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      this.condicionespago = resp.body.list;
      if (this.condicionespago != null && this.condicionespago.length > 0)
        this.objProveedor.codpag = this.condicionespago[0].codpag;
    }, err => {
      this.spinnerService.activarLoading(false);
    })
    console.log(' console.log(this.tident)')
    console.log(this.tident)

    //Variables por defecto
    this.objProveedor.codtpe = 1
    this.tident = "06"

    this.isnatural = true
    this.objProveedor.sexo = 'M'
    this.objProveedor.tident = '01'
    this.identidad = false
    this.tamanoidentidad = 8

  }


  onNexFocus(tipo: string) {
    if (tipo == 'Insert') {
      timerOut(10).then((value: any) => {
        if (value) { this.selectInsertar.nativeElement.focus(); }
      })
    } else {
      timerOut(10).then((value: any) => {
        if (value) { this.selectModificar.nativeElement.focus(); }
      })
    }
  }

  onSelectTipoPersonaIns(codTpe: number) {

    if (codTpe == 1) {
      this.tident = "06"
      this.isnatural = true
    } else {
      this.tident = "999999"
      this.isnatural = false
    }
  }
  @ViewChild('dident') dident: ElementRef;

  onSelectTipoIdentidadIns(tipid: string) {

    if (tipid == "01") {
      this.identidad = false
    } else {
      this.identidad = true
      this.objProveedor.nrodni = ""
      this.objProveedor.nrodni = null;
    }

    this.identidades.forEach(element => {
      if (element.tident == tipid) {
        this.tamanoidentidad = element.tamano;
      }
    });

    timerOut(50).then((value: any) => {
      if (value) { this.dident.nativeElement.focus(); }
    })
  }

  cancelarInsercion() {
    this.cerrar();
  }

  borrarDatos() {
    this.objProveedor = new objProveedorFrm();
    this.disabledGuardar = true;
    //this.objProveedor.fecing = moment(new Date()).format("YYYY-MM-DD");


    setTimeout(() => {
      $('#codTipoDocumento').focus();
    }, 150);
  }

  numerodident = 0;

  guardarProveedor() {

    if (this.objProveedor.dident == null) {
      this.numerodident = 0;
    }
    else {
      this.numerodident = this.objProveedor.dident.length;
    }

    if(this.objProveedor.tident.toString() == '06' || this.objProveedor.tident.toString()  == '01'){
      if (this.tamanoidentidad != 0 && (this.objProveedor.dident == null)) {
        basicAlert('El campo "Doc. de identidad" es requerido y debe tener ' + this.tamanoidentidad + ' dígitos', 'warning', 'Aceptar', null, null, this.dident);
        return;
      }
    }
    if(this.objProveedor.tident.toString() == '06' || this.objProveedor.tident.toString()  == '01'){
      if (this.tamanoidentidad != 0 && this.numerodident != this.tamanoidentidad) {
        basicAlert('El campo "Doc. de identidad" debe tener ' + this.tamanoidentidad + ' dígitos', 'warning', 'Aceptar', null, null, this.dident);
        return;
      }
    }
    
    //validaciones
    if (this.objProveedor.codtpe == null) {
      basicAlert('El campo "Tipo de persona" es obligatorio', 'warning', 'Aceptar', null, null);
      return;
    } else if (this.objProveedor.tident == '' || this.objProveedor.tident == null) {
      //this.funicionesTSIService.alertSweetFocusInput('La descripción es obligatoria', 'warning', '#descripcion');
      basicAlert('El campo "Tipo de identidad" es obligatorio', 'warning', 'Aceptar', null, null);
      return;
      // } else if (this.objProveedor.dident == '' || this.objProveedor.dident == null) {
      //   //this.funicionesTSIService.alertSweetFocusInput('La descripción es obligatoria', 'warning', '#descripcion');
      //   basicAlert('El campo "Doc. de identidad" es obligatorio', 'warning', 'Aceptar', null, null);
      //   return;
    } else if (this.tident != "06" && (this.objProveedor.razonc == '' || this.objProveedor.razonc == null)) {
      //this.funicionesTSIService.alertSweetFocusInput('La descripción es obligatoria', 'warning', '#descripcion');
      basicAlert('El campo "Razón social" es obligatorio', 'warning', 'Aceptar', null, null);
      return;
    } else if (this.tident == "06" && (this.objProveedor.razonc == '' || this.objProveedor.razonc == null)) {
      //this.funicionesTSIService.alertSweetFocusInput('La descripción es obligatoria', 'warning', '#descripcion');
      basicAlert('El campo "Apellidos y nombres" es obligatorio', 'warning', 'Aceptar', null, null);
      return;
    }
    if (this.objProveedor.codtpe == 2 && (this.objProveedor.direc1 == '' || this.objProveedor.direc1 == null)) {
      basicAlert('El campo "Dirección 1" es obligatorio y mayor a 10 dígitos.', 'warning', 'Aceptar', null, null);
      return;
    }

    // if(this.objProveedor.dident.length != this.tamanoidentidad){
    //   basicAlert('El campo "Doc. de identidad" debe ser de '+ this.tamanoidentidad + ' dígitos', 'warning', 'Aceptar', null, null, this.dident);
    //   return;   
    // }

    if (this.identidades != null)
      this.identidades.forEach(element => {
        if (element.tident == this.objProveedor.tident) {
          this.objProveedor.tidentNombre = element.descri;
        }
      });
    if (this.tipopersona != null)
      this.tipopersona.forEach(element => {
        if (element.codtpe == this.objProveedor.codtpe) {
          this.objProveedor.tipopersona = element.destpe;
        }
      });

    if (this.titulolista != null)
      this.titulolista.forEach(element => {
        if (element.codtit == this.objProveedor.codtit) {
          this.objProveedor.titulolista = element.titulo;
        }
      });

    this.ParamDocumento.codtit = 99999;
    this.ParamDocumento.codtitcom = 99999;
    this.ParamDocumento.id_cia = this.objProveedor.id_cia;
    this.ParamDocumento.tipopersona = this.objProveedor.tipopersona;
    //this.ParamDocumento.valident = this.objProveedor.valident;
    this.ParamDocumento.tident = this.objProveedor.tident;
    this.ParamDocumento.codcli = this.objProveedor.codcli;
    //this.ParamDocumento.nombrescompletos = this.objProveedor.nombrescompletos;
  
    this.ParamDocumento.direc1 = (this.objProveedor.direc1 != undefined && this.objProveedor.direc1 != null && this.objProveedor.direc1.length > 0) ? this.objProveedor.direc1.trim() : "";
    this.ParamDocumento.direc2 = (this.objProveedor.direc2 != undefined && this.objProveedor.direc2 != null && this.objProveedor.direc2.length > 0) ? this.objProveedor.direc2.trim() : "";
   

    this.ParamDocumento.apellidopaterno = this.objProveedor.apellidopaterno;
    this.ParamDocumento.email = this.objProveedor.email;
    this.ParamDocumento.apeliidomaterno = this.objProveedor.apeliidomaterno;
    this.ParamDocumento.telefono = this.objProveedor.telefono;
    this.ParamDocumento.nombres = this.objProveedor.nombres;
    this.ParamDocumento.fax = this.objProveedor.fax;
    this.ParamDocumento.nrodni = this.objProveedor.nrodni;
    this.ParamDocumento.sexo = this.objProveedor.sexo;
    this.ParamDocumento.repres = this.objProveedor.repres;

    this.ParamDocumento.titulolista = this.objProveedor.titulolista;

    this.ParamDocumento.codven = this.objProveedor.codven;
    this.ParamDocumento.exoimp = this.objProveedor.exoimp;
    this.ParamDocumento.regret = this.objProveedor.regret;
    //this.ParamDocumento.observ = this.objProveedor.observ;
    //this.ParamDocumento.codtit = this.objProveedor.codtit;
    this.ParamDocumento.codtpe = this.objProveedor.codtpe;
    this.ParamDocumento.razonc = this.objProveedor.razonc.trim();
    this.ParamDocumento.dident = this.objProveedor.dident;
    //this.ParamDocumento.fecing = moment(this.objProveedor.fecing).format("YYYY-MM-DD");
    //this.ParamDocumento.clases = this.clases;

    this.ParamDocumento.codpag = this.objProveedor.codpag;


    this.spinnerService.activarLoading(true);
    this.ProveedorService.insertProveedor(this.ParamDocumento).subscribe((response: any) => {
      console.log(response);
      let codigo = this.ParamDocumento.codcli

      this.toastr.success('Se registró correctamente.','',{ positionClass: 'toast-bottom-left'})
      this.ParamDocumento = new Proveedor();
      this.borrarDatos();
      this.spinnerService.activarLoading(false);
      //this.buscar();
      this.vista = 1
      this.cerrar();
      timerOut(200).then((value: any) => {
        if (value) { 
        const referenciaModal = this.modalService.open(ModificarProveedorComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
        referenciaModal.componentInstance.codpro = codigo;
        }
      })
    }, err => {
      this.spinnerService.activarLoading(false);
      if (err.status >= 500) {
        basicAlert(err.error, 'error', 'Aceptar');
      } else {
        basicAlert(err.error.message, 'warning', 'Aceptar');
        this.vista = 1
        this.cerrar();
      }
    })

  }

  importarDatosSunat() {
    const referenciaModal = this.modalService.open(ImportarSunatComponent, { scrollable: true, backdrop: 'static' });
    referenciaModal.componentInstance.objImageSunat = this._sunatImage;
    referenciaModal.componentInstance.ruc = this.objProveedor.dident;
    referenciaModal.result.then((data) => {


      this.objProveedor.codtpe = 2;
      this.objProveedor.tident = '06';
      this.objProveedor.dident = data.ruc;
      this.tident = "999999"
      this.objProveedor.codcli = data.ruc;
      this.objProveedor.direc1 = data.direc.substring(0, 95);
      this.objProveedor.razonc = data.razonc.substring(0, 75);

      console.log(this.objProveedor.dident);

      this.onSelectTipoIdentidadIns(this.objProveedor.tident)

      console.log(this.objProveedor.dident);


      let digito1 = parseInt(String(data.ruc)[0])
      console.log("data.ruc primero");
      console.log(digito1);

      if (digito1 == 1) {
        this.objProveedor.codtpe = 1;
      }
      if (digito1 == 2) {
        this.objProveedor.codtpe = 2;
      }

    }, (reason) => {
      console.log("reason");
      console.log(reason);
    });


  }

  
  importarDatosDNI() {
    const referenciaModal = this.modalService.open(ImportarDniComponent, { scrollable: true, backdrop: 'static' });
    referenciaModal.componentInstance.objImageSunat = this._sunatImage;
    referenciaModal.componentInstance.ruc = this.objProveedor.dident;
    referenciaModal.result.then((data) => {


      this.objProveedor.codtpe = 1;
      this.objProveedor.tident = '01';
      this.objProveedor.dident = data.ruc;
      this.tident = "06"
      this.objProveedor.codcli = data.ruc;
      this.objProveedor.direc1 = data.direc.substring(0, 95);
      this.objProveedor.razonc = data.razonc.substring(0, 75);

      console.log(this.objProveedor.dident);

      this.onSelectTipoIdentidadIns(this.objProveedor.tident)

      console.log(this.objProveedor.dident);


      let digito1 = parseInt(String(data.ruc)[0])
      console.log("data.ruc primero");
      console.log(digito1);

      if (digito1 == 1) {
        this.objProveedor.codtpe = 1;
      }
      if (digito1 == 2) {
        this.objProveedor.codtpe = 2;
      }

    }, (reason) => {
      console.log("reason");
      console.log(reason);
    });


  }

  onKeyUpNombresCompletos(event: any) {

    this.quitarEspaciosEnBlanco(event.target.value);
    console.log(event.target.value);
    let separacion = event.target.value.replace("  ", " ")

    let NOMBRES = separacion.split(" ");

    if (separacion == '') {
      NOMBRES = [];
    }

    if (NOMBRES.length == 0) {
      this.objProveedor.nombres = '';
      this.objProveedor.apellidopaterno = '';
      this.objProveedor.apeliidomaterno = '';
    }

    if (NOMBRES.length == 1) {
      this.objProveedor.apellidopaterno = '';
      this.objProveedor.apeliidomaterno = '';
      this.objProveedor.nombres = NOMBRES[0];
    }

    if (NOMBRES.length == 2) {
      this.objProveedor.apeliidomaterno = '';
      this.objProveedor.apellidopaterno = NOMBRES[0];
      this.objProveedor.nombres = NOMBRES[1];
    }

    if (NOMBRES.length == 3) {
      this.objProveedor.apellidopaterno = NOMBRES[0];
      this.objProveedor.apeliidomaterno = NOMBRES[1];
      this.objProveedor.nombres = NOMBRES[2];
    }

    if (NOMBRES.length == 4) {
      this.objProveedor.apellidopaterno = NOMBRES[0];
      this.objProveedor.apeliidomaterno = NOMBRES[1];
      this.objProveedor.nombres = NOMBRES[2] + ' ' + NOMBRES[3];
    }
  }
  quitarEspaciosEnBlanco(cadena: string) {
    let espaciosVacios: number = 0;
    for (let index = 0; index < cadena.length; index++) {
      const element = cadena[0];
      if (element == ' ') {
        espaciosVacios = 1;
      }
    }
    //nombresyapellidos
    this.objProveedor.razonc = cadena.replace(cadena.substring(0, espaciosVacios), '');
    if (cadena.includes('  ')) {
      this.objProveedor.razonc = cadena.replace('  ', ' ')
    }
  }
  oneKeyupIdentidad(event: any) {

    if (this.objProveedor.tident == "01") {
      this.objProveedor.nrodni = this.objProveedor.dident;
    }
  }

  onBlurDocIdentidad() {
    console.log("this.objCliente.dident.length")
    console.log(this.objProveedor.dident.length)


  }
  cerrar(){
    this.modalService2.dismiss('canceling');
  }

}
